import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Portal,
  Select,
  Text,
  useBreakpointValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FormEvent, useEffect, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { MdAssignmentTurnedIn, MdDelete } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { AddCourseToModuleModal } from "../../../components/admin/programs/AddCourseToProgramModal";
import { AddModulesToProgramModal } from "../../../components/admin/programs/AddModulesToProgram";
import { CreateProgramAssesmentModal } from "../../../components/admin/programs/CreateProgramAssesmentModal";
import Loading from "../../../components/common/Loading";
import { IProgramAssessment } from "../../../models/admin/programs/assessment/assessment.model";
import {
  IProgramAssessmentModules
} from "../../../models/admin/programs/assessment/programmodules.model";
import { IPrograms } from "../../../models/admin/programs/programs.model";
import program_moduleService from "../../../services/program_service/program_module.service";
import programsService from "../../../services/program_service/programs.service";
import Adminroutes from "../routes";

const AdminProgramSettings = () => {
  const { program_id } = useParams();
  const [gender, setGender] = useState<any[]>([]);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isAssessment, setisAssessment] = useState(false);
  const [programId, setprogramId] = useState("");
  const [program, setprogram] = useState<IPrograms>();
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const [assignModule, setAssignModule] = useState(false);
  const [currentObject, setCurrentObject] = useState<any>();
  const [newStatus, setNewStatus] = useState<any>(1);
  const [addCourseToModule, setAddCourseToModule] = useState(false);
  const [isCustomModalOpen, setCustomModalOpen] = useState(false);
  const [moduleId, setmoduleId] = useState("");
  const [reload, setReload] = useState(false);
  const [programAssessment, setprogramAssessment] = useState<
    IProgramAssessment[]
  >([]);
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [fileteredprogramAssessment, setFilteredprogramAssessment] = useState<IProgramAssessment[]>([]);
  const modalSize = useBreakpointValue({ base: "xs", sm: "sm", md: "sm" });

  const programModuleStatus = [
    {
      text: 'Inactive',
      id: 0
    },
    {
      text: 'Active',
      id: 1
    },
    {
      text: 'In Progress',
      id: 2
    },
    {
      text: 'Stopped',
      id: 3
    },
    {
      text: 'Completed',
      id: 4
    },
    {
      text: 'Result Ready',
      id: 5
    },

  ]

  useEffect(() => {
    if (program_id) setprogramId(program_id);
    programsService.getAProgram(program_id).then((progres) => {
      setprogram(progres.data);
    });
    // getModuleCategories()
    // getModuleCategoriesByProgramId(program_id as string)
    program_moduleService.getModuleCategories().then((res) => {
      // get program assessment/categories
      const categories: IProgramAssessment[] = res.data;
      //get all program modules
      programsService.getProgramModules(program_id).then(async (response) => {
        const moduleCategories: IProgramAssessmentModules[] = response.data;
 
        for (let index = 0; index < categories.length; index++) {
          const category = categories[index];
          //map modules with the same assessment category
          const relatedCategory: IProgramAssessmentModules[] =
            moduleCategories.filter(
              (each) => each.assessment_category_id == category.id
            );
          //array of promises
          const promises = [];
          let course_modules: any[] = [];
          for (let j = 0; j < relatedCategory.length; j++) {
            const module = relatedCategory[j];
            promises.push(
              programsService.getModuleCourses(module.id.toString())
            );
          }

          //resolving all promises
          course_modules = await Promise.all(promises);
          for (let j = 0; j < relatedCategory.length; j++) {
            relatedCategory[j].course_modules = course_modules[j].data
          }
          category.assessmentModules = relatedCategory;
          categories.splice(index, 1, category);
        }
      });
      setprogramAssessment(categories);
      setFilteredprogramAssessment(categories);
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    });
  }, [reload]);

  const openCreateAssessmentModal = async () => {
    setAssignModule(false);
    setAddCourseToModule(false);
    setisAssessment(true);
    onOpen();
  };
  const openAddModulesToProgram = async (id: string) => {
    setisAssessment(false);
    setAddCourseToModule(false);
    setAssignModule(true);
    setSelectedAssessmentId(id);
    onOpen();
  };
  const openAddCourseModuleModal = async (id: string) => {
    setisAssessment(false);
    setAssignModule(false);
    setAddCourseToModule(true);
    // addCourseToModuleDisclosure.onOpen();
    setmoduleId(id);
    onOpen();
  };
  const reloadData = () => {
    setReload(!reload);
    setLoading(true);
  };
  const removeCourseFromModule = async (moduleId: string, courseId: string) => {
    const data = {
      course_id: courseId,
    };
    try {
      const deleteCourse = await programsService.removeCourseFromProgramModule(
        data,
        moduleId
      );
      if (deleteCourse) {
        reloadData();
        toast({
          title: "Delete Course",
          description: "Course removed successfully",
          status: "success",
        });
      }
    } catch (error) {
      toast({
        title: "Delete Course",
        description: "Something went wrong, try again later",
        status: "error",
      });
    }
  };

  const removeModuleFromProgram = async (
    moduleId: string,
    courseId: string
  ) => {
    const data = {
      course_id: courseId,
    };
    try {
      const deleteCourse = await programsService.removeCourseFromProgramModule(
        data,
        moduleId
      );
      if (deleteCourse) {
        reloadData();
        toast({
          title: "Delete Course",
          description: "Course deleted",
          status: "success",
        });
      }
    } catch (error) {
      toast({
        title: "Delete Course",
        description: "Something went wrong, try again later",
        status: "error",
      });
    }
  };

  const openCustomModal = (each: any) => {
    setCurrentObject(each);
    setisAssessment(false);
    setAssignModule(false);
    setAddCourseToModule(false);
    setCustomModalOpen(true);
  };

  const closeCustomModal = () => {
    setCustomModalOpen(false);
  };

  const handleUpdateModuleStatus = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const updateModuleObject = {
      program_id: currentObject?.program_id.toString(),
      module_id: currentObject?.module_id.toString(),
      assessment_category_id: currentObject?.assessment_category_id.toString(),
      status: newStatus,
      has_posting :  true 
    }
    try {
      const updateModuleStatusRes = await programsService.updateProgramModuleStatus(updateModuleObject, currentObject?.id);
      
      toast({
        title: "Module Status",
        description: 'Status Updated Successfully',
        status: "success",
        duration: 3000,
      })
    } catch (e) {
      console.error(e);
      toast({
        title: "Module Status",
        description: 'Something went wrong',
        status: "error",
        duration: 3000,

      })
    }finally{
      closeCustomModal();
    }
  };


  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex        minHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}>
        <Box
          width={["4rem", "4rem", "4rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>

          <Box width={"100%"}>
            <AdminDashboardHeader />

            <Flex
              justifyContent="center"
              bg="#F9F8F8"
              minHeight="100vh"
              bgSize="cover"
            >
              <Box mt="50px" bg="#F9F8F8" height="100%" width={["90%", "90%", "85%", "80%"]}>

                <Box
                  mb='60px'
                  display="flex"
                  alignItems="center"
                  border="1px solid #616161"
                  px="10px"
                  py="7px"
                  width={["160px"]}
                  borderRadius="2px"
                  cursor="pointer"
                >
                  <HiArrowNarrowLeft color="#616161" fontSize="20px" />
                  <Text fontSize="14px" color="#616161" pl="5px" onClick={() => navigate(Adminroutes.Programs)} fontWeight={700}>
                    Back to Programs
                  </Text>
                </Box>
                <Box
                  height="3rem"
                  width="100%"
                  bg="white"
                  boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)"
                  px={8}
                  py={2}
                >
                  <HStack justifyContent="center" gap="2rem">
                    <Text
                      fontSize="20px"
                      textTransform={"uppercase"}
                      color={"#EC3337"}
                      fontWeight={"700"}
                    >
                      {program?.name.toLowerCase()}
                    </Text>
                  </HStack>
                </Box>
                <Box
                  boxShadow="base"
                  width="100%"
                  bg="white"
                  mb="50px"
                  mt={6}
                  py={4}
                  px={8}
                >
                  <Box width="95%" mx="auto">
                    <Text
                      color="#353535"
                      fontSize="16px"
                      pb="20px"
                      fontWeight="600"
                      textTransform={"uppercase"}
                    >
                      {program?.name.toLowerCase()} Content
                    </Text>
                    {programAssessment &&
                      programAssessment.length > 0 &&
                      programAssessment.map((each, index) => (
                        <Box
                          key={index}
                          bg="#FDFDFD"
                          pb="10px"
                          mb="15px"
                          pt="10px"
                        >
                          <Flex justifyContent={"space-between"}>
                            <Text
                              ml="2.5%"
                              color="#616161"
                              fontSize="16px"
                              fontWeight="500"
                              pb="20px"
                            >
                              {" "}
                              {`${index + 1} : ${each.name}`}
                            </Text>
                            <Button
                              colorScheme="red"
                              variant={"outline"}
                              onClick={() => {
                                openAddModulesToProgram(each.id.toString());
                              }}
                              size={"sm"}
                            >
                              Add modules
                            </Button>
                          </Flex>

                          {each.assessmentModules &&
                            each.assessmentModules.map(
                              (assModule, assIndex) => (
                                <Accordion
                                  mr={"30px"}
                                  key={assIndex}
                                  allowToggle
                                >
                                  <AccordionItem>
                                    <h2>
                                      <AccordionButton width={"100%"}>
                                        <Flex
                                          width={"88%"}
                                          justifyContent={"space-between"}
                                        >
                                          <Text>{assModule.module.name}</Text>
                                          <HStack spacing={1}>
                                            <Center
                                              border="1px dashed"
                                              borderRadius="15px"
                                              borderColor="#E5E5E5"
                                              width="30px"
                                              cursor={"pointer"}
                                              height="30px"
                                              onClick={() => {
                                                openAddCourseModuleModal(
                                                  assModule.id.toString()
                                                );
                                              }}
                                              title="Add course to module"
                                            >
                                              <BsPlusLg />
                                            </Center>
                                           
                                            <Center
                                              border="1px solid"
                                              borderRadius="10px"
                                              cursor={"pointer"}
                                              borderColor="#E5E5E5"
                                              width="30px"
                                              height="30px"
                                              onClick={() => {openCustomModal(assModule)}}
                                            >
                                              <MdAssignmentTurnedIn color="red" />
                                            </Center>
                                          </HStack>
                                        </Flex>
                                        <AccordionIcon />
                                      </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4}>
                                      {assModule.course_modules &&
                                        assModule.course_modules.length > 0 &&
                                        assModule.course_modules.map(
                                          (course_modules, courseIndex) => (
                                            <Flex
                                              px={"8px"}
                                              py={"5px"}
                                              textTransform={"capitalize"}
                                              justifyContent={"space-between"}
                                              bg={"#F9F8F8"}
                                              borderRadius={"5px"}
                                              mb={"7px"}
                                              key={courseIndex}
                                            >
                                              <Text>
                                                {course_modules.name.toLowerCase()}
                                              </Text>
                                              <Center
                                                border="1px solid"
                                                borderRadius="10px"
                                                cursor={"pointer"}
                                                borderColor="#E5E5E5"
                                                width="30px"
                                                height="30px"
                                                onClick={() => {
                                                  removeCourseFromModule(
                                                    assModule.id.toString(),
                                                    course_modules.id.toString()
                                                  );
                                                }}
                                              >
                                                <MdDelete color="red" />
                                              </Center>
                                            </Flex>
                                          )
                                        )}
                                    </AccordionPanel>
                                  </AccordionItem>
                                </Accordion>
                              )
                            )}
                        </Box>
                      ))}
                    <Flex justifyContent={"flex-end"}>
                      <Button
                        colorScheme="red"
                        onClick={() => {
                          openCreateAssessmentModal();
                        }}
                        size={"sm"}
                        p="7px"
                        borderRadius={"2px"}
                      >
                        Add assessment category
                      </Button>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
          {isAssessment && (
            <Portal>
              {" "}
              <CreateProgramAssesmentModal
                isOpenAssessment={isOpen}
                onClosed={onClose}
                isAssessment={isAssessment}
                reload={reloadData}
              />{" "}
            </Portal>
          )}
          {assignModule && (
            <Portal>
              {" "}
              <AddModulesToProgramModal
                isOpened={isOpen}
                onClosed={onClose}
                selectedAssessmentId={selectedAssessmentId}
                programId={programId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}
          {addCourseToModule && (
            <Portal>
              {" "}
              <AddCourseToModuleModal
                isOpened={isOpen}
                onClosed={onClose}
                selectedModuleId={moduleId}
                updateRecord={reloadData}
                coursesIds={""}
              />{" "}
            </Portal>
          )}
        </Flex>
      )}
      <Modal isOpen={isCustomModalOpen} onClose={closeCustomModal} size={modalSize}>
        <ModalContent>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Update Module Status</ModalHeader>
            <ModalCloseButton />
            <form onSubmit={handleUpdateModuleStatus}>
              <ModalBody>
                <FormControl mt={4}>
                  <FormLabel>Update Status:</FormLabel>
                  <Select value={newStatus} placeholder="Select an option" name="status" onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => setNewStatus(e.target.value)}>
                    {
                      programModuleStatus?.map((each: any, index: number) => {
                        return (
                          <option key={index} value={each.id}>{each.text}</option>
                        )
                      })
                    }
                  </Select>
                </FormControl>
              </ModalBody>
              <ModalFooter>
                <Button mt={4} type="submit" colorScheme="red">Submit</Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AdminProgramSettings;